import React, { PropsWithChildren } from "react";
import { Box, ToggleButtonProps, Tooltip } from "@mui/material";
import classNames from "classnames";

import { ToggleButton } from "./toolbar.styles";

interface IProps {
  title: string;
  hasOptions?: boolean;
}

const ToolbarToggleButton: React.FC<PropsWithChildren<IProps & ToggleButtonProps>> = ({ title, hasOptions, children, ...props }) => {
  return (
    <Tooltip title={title} placement="right">
      <Box component="span">
        <ToggleButton {...props} className={classNames(props.className, { "has-options": hasOptions })}>
          {children}
        </ToggleButton>
      </Box>
    </Tooltip>
  );
};

export default ToolbarToggleButton;
